import { navigateTo } from '../http/redirect';

function closeEnquiryConfirmation(): void {
    if ( window.router.initialState.isRoutedPopup ) {
        navigateTo( document.body.dataset.baseUrl || '/' );
        return;
    }
    window.router.Rewind();
}

/**
 * @description onDirectoryEnquiryClose handles the event triggered for closing the directory enquiry confirmation
 * @param {Event} event - the native MouseEvent event triggered
 */
function onDirectoryEnquiryClose( event: Event ): void {
    closeEnquiryConfirmation();
}

export {
    onDirectoryEnquiryClose,
};
